// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-view-without-icon[data-v-b9ba1d88]{padding:30px 15px}.login-view-without-icon .caption[data-v-b9ba1d88]{align-items:center;display:flex;font-size:18px;justify-content:center;margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
